var Theme;

(function(window, undefined) {
    Theme = {
        /**
         *
         * Cache elements
         *
         */
        init: function() {

            // Request animation frame
            Theme.raf =
                window.requestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.mozRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                window.oRequestAnimationFrame;

            // Cache elements
            Theme.html = jQuery('html');
            Theme.body = jQuery('body');
            Theme.toggleNavButton = jQuery('.toggle-nav');
            Theme.toggleSubNavButton = jQuery('.menu-item-has-children > a');
            Theme.imagesLinks = jQuery('a[href$="jpg"]')
            Theme.footer = jQuery('.footer');

            // scrollPosition
            Theme.scrollPosition = window.pageYOffset;
        },

        /**
         *
         * Bindings
         *
         */
        bootstrap: function() {
            /* Set vars */
            Theme.init();

            /* Enable JS */
            Theme.html.removeClass('no-js');

            /* Toggle Navigation */
            Theme.toggleNavButton.click(function(e) {
                e.preventDefault();
                Theme.toggleNav();
            });

            /* Toggle subnav */
            Theme.toggleSubNavButton.click(function(e) {
                if (!Theme.toggleNavButton.is(':visible')) return;

                e.preventDefault();
                jQuery(this)
                    .parent()
                    .find('>ul')
                    .slideToggle();
            });

            /* High performance resize event */
            if ('ResizeObserver' in window) {
                var observer = new ResizeObserver(function(elements) {
                    elements.forEach(function(e) {
                        Theme.resizeCallback();
                    });
                });
                observer.observe(document.querySelector('.footer'));
            }

            /* Request animation frame */
            if (Theme.raf) {
                Theme.animationFrame();
            }

            /* Lightbox */
            Theme.imagesLinks.attr('data-fancybox', 'gallery');

            AOS.init({
                once: true,
            });

        },

        animationFrame: function() {
            var scrollTop = window.pageYOffset;
            if (Theme.scrollPosition === scrollTop) {
                Theme.raf.call(window, Theme.animationFrame);
                return;
            } else {
                Theme.scrollPosition = scrollTop;
                Theme.scrollCallback();
                if (!'ResizeObserver' in window) {
                    Theme.resizeCallback();
                }
                Theme.raf.call(window, Theme.animationFrame);
            }
        },

        /**
         *
         * Footer resize
         *
         */
        resizeCallback: function() {
            Theme.body.css('paddingBottom', Theme.footer.outerHeight());
        },

        /**
         *
         * Scrolling
         *
         */
        scrollCallback: function() {
            if (Theme.scrollPosition > 1) {
                Theme.body.addClass('is-scrolled');
            } else {
                Theme.body.removeClass('is-scrolled');
            }
        },

        /**
         *
         * Toggle Navigation
         *
         */
        toggleNav: function() {
            Theme.body.toggleClass('nav--visible');
        },

    };

    Theme.bootstrap();
})(window);
